module.exports = __webpack_public_path__ + "static/age-logo-70f7fc6973555359f5d908badc41d32b.svg";